export const API_BASE_URL = "https://api.rapidtweets.com";
//export const API_BASE_URL = "http://localhost:8000";
export const FRONTEND_BASE_URL = "https://rapidtweets.com";
//export const FRONTEND_BASE_URL = "http://localhost:3000";
